// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"f3e647b3","180":"c278d3f5","208":"a9dda4ad","214":"85659090","419":"c3a60de6","439":"679d9c92","473":"5ff3c059","496":"1115da25","503":"cb8bb6ee","774":"8865e1a9"}[chunkId] + ".chunk.js";
};